module.exports = __webpack_public_path__ + "static/media/iar_responder_other.b308cbfc.svg";